module.exports = __webpack_public_path__ + "static/logo-443b4c43aaa4dfefef6ec63bc2ace26e.svg";